<!-- Button -->
<button mat-icon-button  [routerLink]="['/dashboard']" [skipLocationChange]="true">
    <ng-container [ngTemplateOutlet]="homeIconTpl"></ng-container>
</button>

<!-- Default icon -->
<ng-template #homeIconTpl>
    <mat-icon [svgIcon]="'heroicons_outline:home'"></mat-icon>
</ng-template>